// extracted by mini-css-extract-plugin
export default {"default":"Badge_default__qvlMu","long":"Badge_long__BvM1U"};